export default {"src":"/_next/static/media/bigdata.05450255.svg","height":2500,"width":3415,"blurWidth":0,"blurHeight":0};